import type { AutomationStatus } from '@/types';

/**
 * Whether the backend reports the automation pipeline as actively running.
 *
 * While it runs, `status` carries the current stage name rather than a
 * dedicated "running" value, so anything that is neither terminal nor
 * `not_started` means work is still in flight.
 */
export function isAutomationInProgress(
  status: AutomationStatus | string | undefined | null
): boolean {
  return !!status && status !== 'not_started' && status !== 'completed' && status !== 'failed';
}
